import { useState } from "react";
import { Check } from "lucide-react";
import { staffAuth } from "../lib/api";

export function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null); setSaved(false);
    if (next.length < 8) { setError("New password must be at least 8 characters."); return; }
    if (next !== confirm) { setError("Passwords don't match."); return; }
    setBusy(true);
    try {
      await staffAuth.changePassword(current, next);
      setSaved(true);
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e: any) {
      setError(e?.message || "Could not change password");
    } finally { setBusy(false); }
  }

  return (
    <div className="panel" style={{ marginBottom: 16 }}>
      <div className="panel-header"><h2>Your password</h2></div>
      <form onSubmit={submit} className="stacked-form">
        <label className="form-field"><span>Current password</span>
          <input type="password" value={current} onChange={(e) => { setCurrent(e.target.value); setSaved(false); }} autoComplete="current-password" required />
        </label>
        <div className="form-row-2">
          <label className="form-field"><span>New password</span>
            <input type="password" value={next} onChange={(e) => { setNext(e.target.value); setSaved(false); }} autoComplete="new-password" placeholder="At least 8 characters" required />
          </label>
          <label className="form-field"><span>Confirm new password</span>
            <input type="password" value={confirm} onChange={(e) => { setConfirm(e.target.value); setSaved(false); }} autoComplete="new-password" required />
          </label>
        </div>
        {error && <p className="error-text" role="alert">{error}</p>}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button className="btn-primary" disabled={busy}>{busy ? "Saving…" : "Change password"}</button>
          {saved && <span className="muted small" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--ne-success)" }}><Check size={15} aria-hidden="true" /> Password changed</span>}
        </div>
      </form>
    </div>
  );
}
